/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, inject, OnInit, signal, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { TestToolService } from '../services/test-tool.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { ToastService, ToastType } from '../../shared/toast/toast.service';
import { GenericModalService, ModalSettingsMessage } from '../../shared/generic-modal/generic-modal.service';
import { TestRunResultDto } from '../models/test-run-result-dto';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoStateStoringModule, DxoEditingModule, DxiColumnModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { BizDateColumnDirective } from '../../shared/grid/biz-grid-date.directive';
import { BizUserColumnDirective } from '../../shared/grid/biz-grid-user.directive';
import { DxTemplateModule } from 'devextreme-angular/core';
import { TrackingStatusLabelComponent } from '../../tracking/tracking-status-label.component';
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-test-tool-test-run-results',
  templateUrl: './test-tool-test-run-results.component.html',
  styleUrls: ['./test-tool-test-run-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SvgIconComponent, DxDataGridModule, BizDataGridDirective, DxoStateStoringModule, 
    DxoEditingModule, DxiColumnModule, BizDateColumnDirective, BizUserColumnDirective, 
    DxiButtonModule, DxTemplateModule, TrackingStatusLabelComponent, DatePipe]
})
export class TestToolTestRunResultsComponent implements OnInit {
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  public bizGridFiltervalues = inject(BizGridFiltervalues);
  
  private router = inject(Router); 
  private route = inject(ActivatedRoute);
  private testToolService = inject(TestToolService);
  private modalService = inject(GenericModalService);
  private loadingPanelService = inject(LoadingPanelService);
  private toastService = inject(ToastService);

  currentTestRunId = signal(0);
  currentTestCaseId = signal(0);
  currentTestCaseName = signal('');
  currentTestRunDateTime = signal(new Date());

  currentTestRunResults: TestRunResultDto[] = [];
  stateStorageKey = 'test-tool-test-run-results-component-state';

  ngOnInit(): void {
    this.route.params.subscribe((parms: any) => {
      if (parms.testRunId) {
        this.currentTestRunId.set(parms.testRunId as number);
        this.stateStorageKey = this.stateStorageKey + '-' + this.currentTestRunId();
        void this.refresh();
      }
    });
  }

  async refresh(): Promise<void> {
    try {
      this.loadingPanelService.showLoadingPanelDirect('Loading Test Run Results...');
      await this.loadTestRunData();
    } finally {
      this.loadingPanelService.hideLoadingPanel();
    }
  }

  async startCompare(): Promise<void> {
    try {
      this.loadingPanelService.showLoadingPanelDirect('Comparing documents...');
      await this.testToolService.compareTestRun(this.currentTestRunId());
    }
    catch (err) {
      console.error(err);
      this.toastService.showToast('Compare failed...', ToastType.error);
    }
    finally {
      this.loadingPanelService.hideLoadingPanel();
    }
    await this.refresh();
  }

  async rerunTestRun(): Promise<void> {
    try {
      await this.modalService.confirmDirect('Rerun test run', 'This will create a completely new test run. Continue?');
      try  {
        this.loadingPanelService.showLoadingPanelDirect('Starting test run...');
        const testRunId = await this.testToolService.rerunTestRun(this.currentTestRunId());
        this.toastService.showToast('Test runs started successfully', ToastType.success);
        await this.router.navigate(['/test-tool/test-runs/test-run-results', { testRunId }]);
      }
      catch{
        this.toastService.showToast('Failed to start test run...', ToastType.error);
      }
      finally {
        this.loadingPanelService.hideLoadingPanel();
      }
    } catch {
      // User cancelled or error occurred; do nothing
    }
  }

  doesRowHaveDocumentId(e: any): boolean {
    const testRunResultDto = e.row.data as TestRunResultDto;
    return testRunResultDto.DocumentIdForActual !== undefined && testRunResultDto.DocumentIdForActual !== null;
  }

  goToDocument = (e: any)  => {
    const testRunResultDto = e.row.data as TestRunResultDto;
    const documentIds = `${testRunResultDto.DocumentIdForActual}`;
    void this.router.navigate(['/tracking/result/details', { documentIds }]);
  }

  viewTestCaseRowEvent = (e: any) => {
    const presentationTestRunResult = e.row.data as TestRunResultDto;
    void this.router.navigate(['/test-tool/test-cases/test-case-interchanges', { 
      testCaseId: presentationTestRunResult.TestCaseId, 
      testCaseName: presentationTestRunResult.TestCaseName,
      expandInterchangeId: presentationTestRunResult.TestCaseInterchangeId
    }]);
  }

  goToVisualCompare = (e: any) => {
    void this.goToVisualCompareShared(e.row.data as TestRunResultDto, true);
  };

  async goToVisualCompareShared(testRunResultDto: TestRunResultDto, parsed: boolean): Promise<void> {
    await this.router.navigate(['/test-tool/test-runs/test-run-results/compare', {
      testRunId: this.currentTestRunId(),
      testRunDocumentsId: testRunResultDto.TestRunDocumentId,
      documentIdForActual: testRunResultDto.DocumentIdForActual,
      parsed,
      testCaseId: testRunResultDto.TestCaseId,
      testCaseName: testRunResultDto.TestCaseName,
      testCaseInterchangeId: testRunResultDto.TestCaseInterchangeId

    }], this.getVisualCompareNavigationExtras());
  };

  getVisualCompareNavigationExtras(): NavigationExtras {
    const gridInstance = this.grid?.instance;
    const filteredDataSource = gridInstance?.getDataSource();

    let isGrouped = false;
    const loadOptions = filteredDataSource.loadOptions();
    isGrouped = Array.isArray(loadOptions.group) && loadOptions.group.length > 0;

    let filteredTestRunResultDtos: TestRunResultDto[] = [];

    if (isGrouped) {
      filteredTestRunResultDtos = this.extractItemsFromGroups(filteredDataSource.items());
    } else {
      filteredTestRunResultDtos = filteredDataSource.items() as TestRunResultDto[];
    }

    const filteredTestRunDocumentMetadata = filteredTestRunResultDtos
      .map(testRunResultDto => ({
        TestRunDocumentId: testRunResultDto.TestRunDocumentId,
        DocumentIdForActual: testRunResultDto.DocumentIdForActual,
        TestCaseId: testRunResultDto.TestCaseId,
        TestCaseName: testRunResultDto.TestCaseName,
        TestCaseInterchangeId: testRunResultDto.TestCaseInterchangeId,
        SortOrder: testRunResultDto.SortOrder
      }));

    const navigationExtras: NavigationExtras = {
      state: {
        navigationTestRunDocumentMetadata: filteredTestRunDocumentMetadata
      }
    };

    return navigationExtras;
  }

  extractItemsFromGroups(groups: any[]): TestRunResultDto[] {
    return groups.flatMap(group => [...(group.items ?? []), ...(group.collapsedItems ?? [])]) as TestRunResultDto[];
  }

  downloadAllTestRunFiles = (e: any) => {
    const testRunResultDto = e.row.data as TestRunResultDto;
    void this.testToolService.downloadAllTestRunFiles(testRunResultDto.TestRunDocumentId);
  }

  internalDisplayErrorMessage(errorMessage: string, defaultMessage: string): string {
    return errorMessage
      ? errorMessage.length > 150
        ? errorMessage.substring(0, 150) + '...'
        : errorMessage
      : defaultMessage;
  }

  viewFullErrorMessage(e: any) {
    const testRunResultDto = e.data as TestRunResultDto;
    const errorMessage = testRunResultDto.ErrorMessage;

    if (errorMessage !== undefined && errorMessage !== null && errorMessage !== '') {
      const html = '<pre>' + errorMessage + '</pre>';
      const modalSettings = new ModalSettingsMessage('Description', html);
      modalSettings.size = 'lg';
      void this.modalService.message(modalSettings);
    }
  }

  private async loadTestRunData(): Promise<void> {
    const testRun = await this.testToolService.getTestRunByTestRunId(this.currentTestRunId());
    if (!testRun) {
      return;
    }

    this.currentTestCaseId.set(testRun.TestCaseId);
    this.currentTestCaseName.set(testRun.TestCaseName);
    this.currentTestRunDateTime.set(testRun.RunDateTime);

    const [testRunResults, testCaseInterChanges] = await Promise.all([
      this.testToolService.getTestRunResults(this.currentTestRunId()),
      this.testToolService.getTestCaseInterchangesForTestCase(this.currentTestCaseId())
    ]);

    if (testRunResults && testCaseInterChanges) {
      this.processTestRunResults(testRunResults, testCaseInterChanges);
    }
  }

  private processTestRunResults(testRunResults: TestRunResultDto[], testCaseInterChanges: { Id: number; Note: string; }[]): void {
    const interchangeMap = new Map(testCaseInterChanges.map(tc => [tc.Id, tc.Note]));
    this.currentTestRunResults = testRunResults.map(item => this.mapTestRunResult(item, interchangeMap));
  }

  private mapTestRunResult(item: TestRunResultDto, interchangeMap: Map<number, string>): TestRunResultDto {
    const { testStatusText, defaultErrorMessage } = this.getTestStatusInfo(item);
    return {
      ...item,
      TestCaseId: this.currentTestCaseId(),
      TestCaseName: this.currentTestCaseName(),
      TestCaseInterchangeNote: interchangeMap.get(item.TestCaseInterchangeId),
      TestStatusText: testStatusText,
      ErrorMessage: this.internalDisplayErrorMessage(item.ErrorMessage, defaultErrorMessage)
    };
  }

  private getTestStatusInfo(item: TestRunResultDto): { testStatusText: string; defaultErrorMessage: string; } {
    switch (item.TestStatus) {
      case true:
        return { testStatusText: 'Success', defaultErrorMessage: 'The compare succeeded' };
      case false:
        return {
          testStatusText: item.Accepted ? 'Accepted' : 'Failed',
          defaultErrorMessage: 'The compared failed, but no error message was provided by the compare plugin'
        };
      default:
        return { testStatusText: 'Pending', defaultErrorMessage: 'The compare has not been run yet' };
    }
  }
}
